export default __webpack_public_path__ + "static/media/upload-ecommerce-2.28f91120.webp";